import React, { forwardRef } from "react";
import ReactSelect, { components as defaultComponents } from "react-select";
import { cn } from "~/lib/utils.ts";

export type SelectComponents = typeof defaultComponents;

// const LazyReactSelect = lazy(() => import("react-select"));
export const SelectDropDown = forwardRef<
  React.ElementRef<typeof ReactSelect>,
  React.ComponentPropsWithoutRef<typeof ReactSelect> & {
    components?: Partial<SelectComponents>;
    coverTriggerWidth?: boolean;
    onModal?: boolean;
  }
>((props, ref) => {
  return (
    <ReactSelect
      className={cn(
        "appearance-none rounded-2xl border shadow-sm outline-none focus-within:border-secondary-500 focus-within:ring-1 focus-within:ring-secondary-500 focus:outline-none focus:ring-0",
        props.className,
      )}
      classNamePrefix="react-select"
      ref={ref}
      styles={{
        control: (base, state) => ({
          ...base,
          borderColor: state.isFocused ? "transparent" : "",
          boxShadow: "none",
          outline: "none",
          border: state.isFocused ? "transparent" : "none",
          borderRadius: "1rem",
          "&:hover": {
            borderColor: state.isFocused ? "transparent" : "",
            border: "none",
            outline: "none",
            boxShadow: "none",
          },
        }),
        indicatorSeparator: (base) => ({
          ...base,
          backgroundColor: "transparent",
        }),
        input: (base) => ({
          ...base,
          height: "2rem",
          verticalAlign: "middle",
        }),
        option: (base, state) => ({
          ...base,
          color: state.isSelected ? "var(--black)" : "var(--black)",
          fontWeight: state.isSelected ? "600" : "500",
          backgroundColor: state.isSelected
            ? "var(--dropdown-highlighter)"
            : // : state.isFocused
              //   ? "var(--dropdown-highlighter)"
              "",
          "&:active": {
            backgroundColor: state.isSelected
              ? "var(--dropdown-highlighter)"
              : //   : state.isFocused
                //     ? "var(--dropdown-highlighter)"
                "",
          },
          "&:hover": {
            backgroundColor: "var(--dropdown-highlighter)",
          },
          borderRadius: "16px",
          fontSize: "14px",
        }),
        menu: (base) => ({
          ...base,
          width: props?.coverTriggerWidth ? "100%" : "fit-content",
          right: 0,
          padding: `8px 12px`,
          border: "border-neutral-200",
          borderRadius: "16px",
        }),
        menuPortal: (base) => ({
          ...base,
          zIndex: 9999,
        }),
        menuList: (base) => ({
          ...base,
          borderRadius: "8px",
        }),
      }}
      {...props}
      menuPortalTarget={props.onModal ? null : document.body} // Render the dropdown menu in a portal
      menuPlacement="auto" // Automatically adjust placement (top/bottom)
      menuShouldScrollIntoView={true} // Ensures the dropdown scrolls into view
      classNames={{
        ...props.classNames,
        menuList: () => "",
        option: (state) => {
          return cn(state.isSelected && "font-Medium", "px-4! py-2");
        },
      }}
      components={{
        ...defaultComponents,
        ...props.components,
      }}
    />
  );
});

SelectDropDown.displayName = "Select";
